export const TRANSCRIPTIONS = 'transcriptions';
export const REQUESTS_SUMMARY = 'requestsSummary';
export const EVERCALL_REGISTRATION_LIMIT = 'evercallRegistrationLimit';
export const ACCOUNT_FILTER_ACTIVITY = 'accountFilterActivity';

export const featureToggle = {
  [REQUESTS_SUMMARY]: {
    cookieName: REQUESTS_SUMMARY,
  },
  [EVERCALL_REGISTRATION_LIMIT]: {
    cookieName: EVERCALL_REGISTRATION_LIMIT,
  },
  [TRANSCRIPTIONS]: {
    cookieName: TRANSCRIPTIONS,
  },
  [ACCOUNT_FILTER_ACTIVITY]: {
    cookieName: ACCOUNT_FILTER_ACTIVITY,
  },
};
